import React from 'react';
import { Link } from 'react-router-dom';
import formatDate from 'utils/formatDate';

const OutletItem = ({ data }) => (
  <div className="grid__item large--one-half product-item-wrapper">
    <div className="product-item background-color-white">
      {data.featured_image ? (
        <div
          className="product-item__image"
          style={{
            backgroundImage: `url('${data.featured_image}')`,
          }}
        >
          <img width="270" height="200" src={data.featured_image} alt={data.name} />
        </div>
      ) : null}

      <div className="product-item__inner">
        <div className="product-item__head">
          <div className="product-item__name">
            {data.name}
          </div>
          <div className="product-item__discount">
            {data.countdown_end ? (
              <span>
                {data.discount}
                <span className="percent">
%
                </span>
              </span>
            ) : null}
          </div>
        </div>

        {data.countdown_end ? (
          <div className="product-item__discount-end">
            <i className="icon-tags" />
            Diskon berlaku sampai:
            {' '}
            {formatDate(data.countdown_end.timestamp)}
          </div>
        ) : null}

        <div className="product-item__location mb-30">
          <i className="icon-location" />
          <div className="product-item__location-name">
            {data.address}
          </div>
        </div>
        
        <Link className="button button--secondary button--small button--uppercase button--wide" to={`/outlets/details/${data.id}`}>Lihat Detail</Link>
      </div>
    </div>
  </div>
);

export default OutletItem;



// WEBPACK FOOTER //
// ./src/pages/Branches/item.js